<template>
  <div :class="type" class="validate-user">
    <div class="validate-user-head">
      <div class="title">
        {{ $t('payment.validateUser.title') }}
      </div>
      <div class="icon-wrapper" @click="openUserGuide">
        <div class="user-arrow"></div>
        <div class="icon-question" @click="handleQuestion"></div>
      </div>
    </div>
    <div class="desc" v-if="!props.validatedUser">
      {{ $t('payment.validateUser.desc') }}
    </div>
    <div class="input-box" v-if="!props.validatedUser">
      <input :value="localCpUserId" @input="updateLocalCpUserId" class="input" type="text" :placeholder="$t('payment.validateUser.enterUserId')">
      <button class="btn submit-btn" @click="validateUser">{{ $t('payment.validateUser.submit') }}</button>
    </div>
    <div class="userinfo" v-if="props.validatedUser">
      <div class="user-info-wrap">
        <div class="item id">
          <span class="label">{{ $t('payment.userDialog.id') }}:</span>
          <span class="value">{{ props.cpUserInfo.cpUserId }}</span>
        </div>
        <div class="item name">
          <span class="label">{{ $t('payment.userDialog.name') }}:</span>
          <span class="value">{{ props.cpUserInfo.cpNickName }}</span>
        </div>
      </div>
      <div class="reset-btn" @click="resetUserInfo">{{ $t('payment.userDialog.cancelInput') }}</div>
    </div>
    <div v-if="showImageViewer">
      <el-image-viewer
        v-if="showImageViewer"
        hide-on-click-modal
        :url-list="imageList"
        :initial-index="0"
        :z-index="9999"
        teleported
        @close="closeImageViewer"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, computed } from 'vue'
import { isMobile } from '@/utils'
// import userGuideImg from '@/assets/imgs/user-guide.jpg'
import pcENuserGuideImg from '@/assets/imgs/userGuide/pc-en.jpg'
import pcVNuserGuideImg from '@/assets/imgs/userGuide/pc-vi.jpg'
import pcHKuserGuideImg from '@/assets/imgs/userGuide/pc-hk.jpg'
import pcTHuserGuideImg from '@/assets/imgs/userGuide/pc-th.jpg'
import pcIDuserGuideImg from '@/assets/imgs/userGuide/pc-id.jpg'
import mobileENuserGuideImg from '@/assets/imgs/userGuide/mobile-en.jpg'
import mobileVNuserGuideImg from '@/assets/imgs/userGuide/mobile-vi.jpg'
import mobileHKuserGuideImg from '@/assets/imgs/userGuide/mobile-hk.jpg'
import mobileTHuserGuideImg from '@/assets/imgs/userGuide/mobile-th.jpg'
import mobileIDuserGuideImg from '@/assets/imgs/userGuide/mobile-id.jpg'
import { ElImageViewer } from 'element-plus'
import { showImagePreview } from 'vant'
import { toastService } from '@/utils/toastService'
import { useI18n } from 'vue-i18n'
import { useLog } from '@/composables/useLog'
const log = useLog()
const { t, locale } = useI18n()
const userGuideImg = computed(() => {
  if (locale.value === 'vi') {
    return isMobile ? mobileVNuserGuideImg : pcVNuserGuideImg
  } else if (['hk', 'tw'].includes(locale.value)) {
    return isMobile ? mobileHKuserGuideImg : pcHKuserGuideImg
  } else if (locale.value === 'th') {
    return isMobile ? mobileTHuserGuideImg : pcTHuserGuideImg
  } else if (locale.value === 'id') {
    return isMobile ? mobileIDuserGuideImg : pcIDuserGuideImg
  } else {
    return isMobile ? mobileENuserGuideImg : pcENuserGuideImg
  }
})

const type = isMobile ? 'mobile' : 'pc'
const showImageViewer = ref(false)
const imageList = computed(() => [userGuideImg.value])

const openUserGuide = () => {
  if (isMobile) {
    const images = imageList.value
    showImagePreview({
      images,
      closeable: true,
      closeIconPosition: 'top-right',
      showIndex: false,
      closeOnClickOverlay: true
    })
  } else {
    showImageViewer.value = true
    document.body.classList.add('lock-scroll')
  }
}

const closeImageViewer = () => {
  showImageViewer.value = false
  document.body.classList.remove('lock-scroll')
}

const props = defineProps({
  validatedUser: {
    type: Boolean,
    default: false
  },
  cpUserInfo: {
    type: Object,
    default: () => ({})
  },
  cpUserId: {
    type: [String, Number],
    default: ''
  }
})

const emit = defineEmits(['update:cpUserId', 'validate', 'reset'])

const localCpUserId = ref(props.cpUserId)
const updateLocalCpUserId = (e) => {
  let newVal = e.target.value
  newVal = newVal.replace(/\s+/g, '')
  newVal = newVal.toUpperCase()
  localCpUserId.value = newVal
  emit('update:cpUserId', newVal)
}

watch(() => props.cpUserId, (newVal) => {
  localCpUserId.value = newVal
})

watch(localCpUserId, (newVal) => {
  emit('update:cpUserId', newVal)
})

const validateUser = () => {
  if (!localCpUserId.value) {
    toastService.show(t('payment.validateUser.enterUserId'))
    return
  }
  emit('validate')
}

const handleQuestion = () => {
  log.track('payment_help_click', {})
}

const resetUserInfo = () => {
  emit('reset')
}

</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>
